export default __webpack_public_path__ + "static/media/Illustration_Attention.29976a30.png";